import type { Theme } from '@mui/material';
import type { /*Components, */ Palette, PaletteColor } from '@mui/material/styles';

import { fontSizeLarge, fontSizeMedium, fontSizeSmall, fontSizeXSmall } from '@/mui/components/constants';

const fontSizes = {
  xSmall: fontSizeXSmall,
  small: fontSizeSmall,
  medium: fontSizeMedium,
  large: fontSizeLarge,
};

export const CUSTOM_ATTRIBUTE_COLOR = 'data-0';

export default function MUIRating(theme: Theme) /*: Components['MuiRating']*/ {
  const variants = Object.keys(theme.palette).filter(
    (key) => !!(theme.palette[key as keyof Palette] as PaletteColor).contrastText,
  );

  return {
    defaultProps: {
      color: 'warning',
    },
    styleOverrides: {
      root: {
        fontSize: 'inherit',
      },
    },
    variants: [
      ...variants.map((key) => ({
        props: { [CUSTOM_ATTRIBUTE_COLOR]: key },
        style: {
          color:
            key === 'neutral' ? theme.palette.shades[900] : (theme.palette[key as keyof Palette] as PaletteColor)?.main,
        },
      })),
      ...Object.entries(fontSizes).map(([key, fontSize]) => ({
        props: { size: key },
        style: {
          fontSize,
        },
      })),
    ],
  };
}
